let activeDevice = null;
let activeCharacteristic = null;

export const setElectronBlePrinterSession = (device, characteristic) => {
  activeDevice = device || characteristic?.service?.device || null;
  activeCharacteristic = characteristic || null;
};

export const getElectronBlePrinterSession = () => {
  const device = activeDevice || activeCharacteristic?.service?.device || null;
  if (!device?.gatt?.connected || !activeCharacteristic) return null;
  return { device, characteristic: activeCharacteristic };
};

export const clearElectronBlePrinterSession = (deviceId = "") => {
  const currentId = String(activeDevice?.id || "");
  if (deviceId && currentId && String(deviceId) !== currentId) return;
  activeDevice = null;
  activeCharacteristic = null;
};
